import { devEnv } from 'services/constants';
import { Email } from 'types/ContactNote';
import { getHostBaseUrl } from 'utils/browserUtil';

const getContactNoteFromEmail = async (email: File, isWena = false): Promise<Email> => {
  const formData = new FormData();
  formData.append('msgFile', email);
  // CLM mode needs to use window.location.origin for running credentials with shell cmd
  // fixes: Request cannot be constructed from a URL that includes credentials
  const baseUrl = isWena ? getHostBaseUrl() : window.location.origin;
  try {
    const response = await fetch(baseUrl + `/backEnd/noteService/api/frontend/msg`, {
      method: 'POST',
      body: formData,
      credentials: devEnv || isWena ? 'include' : 'same-origin',
    });
    if (!response.ok) {
      throw new Error(`Upload failed: ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    throw new Error(`Upload fail: ${err}`);
  }
};

const contactNoteFromEmailService = { getContactNoteFromEmail };

export default contactNoteFromEmailService;
